<template>
  <button
    type="button"
    :aria-label="ariaLabel"
    :aria-labelledby="ariaLabelledby"
    :aria-describedby="ariaDescribedby"
    :aria-expanded="ariaExpanded"
    :aria-haspopup="ariaHaspopup"
    :aria-controls="ariaControls"
    class="rounded-2xl bg-tertiary-200 text-primary-A900 font-normal text-base [ flex items-center gap-x-3 ] [ px-4 py-2 ]"
  >
    <slot />

    <svg-icon-close class="text-left text-black cursor-pointer ml-4" width="10" height="10" />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  // button accessability props
  ariaLabel?: string;
  ariaLabelledby?: string;
  ariaDescribedby?: string;
  ariaExpanded?: boolean;
  ariaHaspopup?: boolean;
  ariaControls?: string;
}>();
</script>
